const searchViewModule = () => import(/* webpackChunkName: 'components/search/searchView' */'./searchElastic');
const biasingSearchViewModule = () => import(/* webpackChunkName: 'components/biasingSearchParameters' */'../biasingSearchParameters/biasingSearchParameters');
const popinParticipantsViewModule = () => import(/* webpackChunkName: 'components/popinParticipantsView' */'../popinParticipants/popinParticipants');
const resultsListViewModule = () => import(/* webpackChunkName: 'components/search/resultListView' */'./resultList/resultList');
const searchFiltersViewModule = () => import(/* webpackChunkName: 'components/search/filtersView' */'../searchFilters/searchFilters');
const dayVisitorViewModule = () => import(/* webpackChunkName: 'components/search/dayVisitorView' */'./dayVisitor/dayVisitor');
const sliderPhotosModule = () => import(/* webpackChunkName: 'components/sliderPhotos' */'../sliderPhotos/sliderPhotos');
const startingPriceModule = () => import(/* webpackChunkName: 'components/startingPrice' */'../../components/startingPrice/startingPrice');

import { SearchModel } from './searchElasticModel';
import { storeSearchView } from '../storeSearchParameters/storeSearchParameters';

export const SearchController = Backbone.View.extend({
  /**
   * Init controller view
   * @param {Object} options
   * @param {string} options.el - Search contents main container css selector
   * @param {boolean} options.hasFilters - if this search engine use filters
   * @param {Object} options.resultList - result list main container
   * @param {boolean} options.hasPagination
   */
  initialize(options = {}) {
    const $searchEngine = $('#js-searchEngine');
    const defaultOptions = {
      el: typeof options.el !== 'undefined' ? $(options.el) : $searchEngine,
      hasFilters: typeof options.hasFilters !== 'undefined' ? options.hasFilters : $('#js-filtersContainer').length
    };

    if ((typeof SEARCH_SCRIPTS !== 'undefined' && SEARCH_SCRIPTS.COLLECTION !== '') || $('.js-dayVisitor').length) {
      const $searchFilters = $('#js-searchFilters');
      this.options = typeof options !== 'undefined' ? options : defaultOptions;
      this.hasResultsList = typeof isResultList !== 'undefined' && isResultList;
      this.setElement(typeof this.options.el !== 'undefined' ? this.options.el : $searchEngine);
      this.$resultList = typeof this.options.resultList !== 'undefined' ? this.options.resultList : $('#js-resultListContainer');
      this.$searchForm = typeof this.options.searchForm !== 'undefined' ? this.options.searchForm : this.$el;
      this.hasFilters = this.options.hasFilters || $searchFilters.length > 0;
      this.hasPagination = typeof this.options.hasPagination !== 'undefined' ? $('#js-resultList').length ? $('#js-resultList[data-has-pagination="true"]').length && this.options.hasPagination : this.options.hasPagination : false;
      this.model = new SearchModel(this.options);
      this.isFacetCapacity = $('#js-form-capacity').length;
      this.firstLoad = true;
      this.isDayVisitor = typeof isDayVisitor !== 'undefined' && isDayVisitor;

      this.listenTo(dispatcher, 'search:displayLoader', this.displaySearchLoader);

      searchViewModule().then(({SearchView}) => {
        // instanciation de la vue du moteur
        this.searchView = new SearchView({
          model: this.model,
          element: this.$searchForm,
          hasFilters: this.hasFilters,
          datePickerOptions: typeof this.options.datePickerOptions !== 'undefined' ? this.options.datePickerOptions : {}
        });

        // instanciation de la vue des filtres
        if (this.hasFilters) {
          searchFiltersViewModule().then(({FiltersView}) => {
            this.Filters = new FiltersView({
              element: $searchFilters,
              model: this.model
            });
          });
        }

        // instanciation de la vue de la liste de résultat (optionnel)
        if (this.hasResultsList) {
          resultsListViewModule().then(({ResultsListView}) => {
            //Initialisation of PopinParticipants
            this.resultsListView = new ResultsListView({
              element: this.$resultList,
              model: this.model,
              cartouche: this.cartouche,
              hasPagination: this.hasPagination,
              hasMulticottage: this.searchView.mainEngineModel.getResume().accommodationNb > 1
            });
          });

          popinParticipantsViewModule().then(({PopinParticipantsView}) => {
            //Initialisation of PopinParticipants
            new PopinParticipantsView(this.model);
          });
        }

        if (this.isDayVisitor) {
          dayVisitorViewModule().then(({DayVisitorView}) => {
            new DayVisitorView({element: '#js-searchEngine', 'model': this.model});
          });
        }

        this.initOnLoad(this.model);
        new storeSearchView(this.model);

        //-- reset storage if back from resa
        sessionStorage.removeItem('upgradeAccepted');

        //end of load =>
        this.firstLoad = false;
      });
    }

    if (SEARCH_SCRIPTS.COLLECTION !== GLOBAL_SCRIPTS.UNIVERS.toUpperCase() + '_GEO') {
      biasingSearchViewModule().then(({BiasingSearchView}) => {
        new BiasingSearchView();

        if (SEARCH_SCRIPTS.PAGETYPE === 'PRODUCT_COTTAGES') {
          dispatcher.trigger('cookie:updateBiasingSearch', PRODUCT_SCRIPTS.PRODUCT_CODE, 2);
        }
      });
    }
  },

  /**
   * Display loader
   * @param {(string|number)} items
   * @param {boolean} append
   */
  displaySearchLoader(items = null, append = false) {
    let domain, itemSelector;

    switch (SEARCH_SCRIPTS.PAGETYPE) {
      case 'SINGLECLICK':
      case 'SINGLECLICK_PARTNER':
        domain = 'sck';
        itemSelector = '.accCart';
        break;
      case 'PRODUCT_COTTAGES':
        domain = 'park';
        itemSelector = '.accCart';
        break;
      default :
        domain = 'search';
        itemSelector = '.cartoucheDomain-container';
        break;
    }

    itemSelector = items !== null ? items : itemSelector;
    loader.displayGhost('#js-resultList', domain, itemSelector, append);
  },

  initOnLoad: function (model) {
    const successCallback = datas => {
      if (datas.status === 'success') {
        // update global participants rules
        if (typeof oParticipantsRules !== 'undefined') {
          if (typeof datas.results.filter.multiparticipants !== 'undefined') {
            oParticipantsRules.adults.max = datas.results.filter.multiparticipants.maxAdults;
            oParticipantsRules.seniors.max = datas.results.filter.multiparticipants.maxSeniors;
            oParticipantsRules.babies.max = datas.results.filter.multiparticipants.maxBabies;
            oParticipantsRules.children.max = datas.results.filter.multiparticipants.maxChildren;
            oParticipantsRules.pets.max = datas.results.filter.multiparticipants.maxPets;
            oParticipantsRules.maxParticipants = datas.results.filter.multiparticipants.maxPersons;
          }

          dispatcher.trigger('searchView:updateSearchEngineValues', ajaxParams, oParticipantsRules);
        }

        // Resubmit search when list is not update
        const basket = sessionStorage.getItem('basketDatas');
        const basketDatas = basket !== null ? JSON.parse(basket) : {};
        const cottagetoselect = parseInt($('.js-basketMulticottage').attr('data-cottagetoselect'));

        if (basket !== null && !(basketDatas.cottagesSelected[0].isFilled && basketDatas.cottagesSelected[1].isFilled) && ((basketDatas.cottagesSelected[0].isFilled && cottagetoselect === 1) || (basketDatas.cottagesSelected[1].isFilled && cottagetoselect === 2))) {
          dispatcher.trigger('searchView:submitSearch');
        }

        // update durations
        if (typeof SEARCH_SCRIPTS !== 'undefined' && $.inArray('durationcp', SEARCH_SCRIPTS.MAIN_FACETS) !== -1) {
          dispatcher.trigger('duration:updateDurationValues', datas.results.filter.durationcp.values);
        }

        sliderPhotosModule().then(({sliderPhotos}) => {
          //Initialisation of product photos slider
          sliderPhotos.initialize(datas.results.results);
        });

        // update json results
        model.set({'JSON_results': datas}, {'silent': true});
      }
    };

    // récupération des paramètres de recherche
    dispatcher.trigger('searchModel:updateSearchParams', false);
    let ajaxParams = this.model ? this.model.get('ajaxParametersCache') : {};

    // on va chercher le json
    genericAjaxCall({
      ajaxUrl: SEARCH_SCRIPTS.URL_API_SEARCH,
      ajaxParams: ajaxParams,
      successCallback: successCallback,
      dataType: 'json',
      type: 'GET'
    });
  }
});